<mat-nav-list>
  <ul>
    <li mat-list-item *ngIf="showHelp">
      <a class="item-menu" [routerLink]="helpPath" [routerLinkActive]="['is-active']">
        <mat-icon color="primary" class="big-icon" appTooltip="Centre d'aide">question_mark</mat-icon>
      </a>
    </li>
    <li mat-list-item>
      <a class="item-menu" [routerLink]="notificationsPath" [routerLinkActive]="['is-active']">
        <mat-icon color="primary" class="big-icon" [matBadge]="notificationsCount" [appTooltip]="notificationsTooltip"
          [matBadgePosition]="'above after'" matBadgeColor="warn" [matBadgeSize]="'small'">notifications</mat-icon>
      </a>
    </li>
  </ul>
</mat-nav-list>